export default __webpack_public_path__ + "static/media/careerLife.4f63e5ac.jpeg";